import { render, staticRenderFns } from "./EditLessonHourAmount.vue?vue&type=template&id=f3d5c518&scoped=true"
import script from "./EditLessonHourAmount.vue?vue&type=script&lang=js"
export * from "./EditLessonHourAmount.vue?vue&type=script&lang=js"
import style0 from "./EditLessonHourAmount.vue?vue&type=style&index=0&id=f3d5c518&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d5c518",
  null
  
)

export default component.exports